<section class="funcionario-shell">
  <header class="funcionario-hero">
    <div>
      <h2 class="funcionario-title">{{ isEditMode ? 'Editar Funcionário' : 'Novo Funcionário' }}</h2>
      <p class="funcionario-subtitle">Preencha os dados cadastrais do funcionário.</p>
    </div>
    <span class="funcionario-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="funcionarioForm" (ngSubmit)="salvarFuncionario()" id="funcionarioForm" class="funcionario-card">
    <div class="form-section">
      <h3>Dados Pessoais</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nome" class="form-label">*Nome</label>
          <input type="text" id="nome" formControlName="nome" class="form-control"
            [ngClass]="{ 'is-invalid': funcionarioForm.get('nome')?.invalid && funcionarioForm.get('nome')?.touched }">
          <div *ngIf="funcionarioForm.get('nome')?.invalid && funcionarioForm.get('nome')?.touched" class="invalid-feedback">
            Nome é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="sobrenome" class="form-label">*Sobrenome</label>
          <input type="text" id="sobrenome" formControlName="sobrenome" class="form-control"
            [ngClass]="{ 'is-invalid': funcionarioForm.get('sobrenome')?.invalid && funcionarioForm.get('sobrenome')?.touched }">
          <div *ngIf="funcionarioForm.get('sobrenome')?.invalid && funcionarioForm.get('sobrenome')?.touched" class="invalid-feedback">
            Sobrenome é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="cpf" class="form-label">*CPF</label>
          <input type="text" id="cpf" formControlName="cpf" class="form-control" mask="000.000.000-00"
            [ngClass]="{ 'is-invalid': funcionarioForm.get('cpf')?.invalid && funcionarioForm.get('cpf')?.touched }">
          <div *ngIf="funcionarioForm.get('cpf')?.invalid && funcionarioForm.get('cpf')?.touched" class="invalid-feedback">
            CPF é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="telefone" class="form-label">*Telefone</label>
          <input type="text" id="telefone" formControlName="telefone" class="form-control" mask="(00) 00000-0000"
            [ngClass]="{ 'is-invalid': funcionarioForm.get('telefone')?.invalid && funcionarioForm.get('telefone')?.touched }">
          <div *ngIf="funcionarioForm.get('telefone')?.invalid && funcionarioForm.get('telefone')?.touched" class="invalid-feedback">
            Telefone é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="cargoId" class="form-label">*Cargo</label>
          <select id="cargoId" formControlName="cargoId" class="form-control"
            [ngClass]="{ 'is-invalid': funcionarioForm.get('cargoId')?.invalid && funcionarioForm.get('cargoId')?.touched }">
            <option [ngValue]="null">Selecione um cargo</option>
            <option *ngFor="let cargo of cargos" [ngValue]="cargo.id">{{ cargo.descricao }}</option>
          </select>
          <div *ngIf="funcionarioForm.get('cargoId')?.invalid && funcionarioForm.get('cargoId')?.touched" class="invalid-feedback">
            Cargo é obrigatório.
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Endereço</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="cep" class="form-label">CEP</label>
          <input type="text" id="cep" formControlName="cep" class="form-control" mask="00000-000">
        </div>

        <div class="col-md-6">
          <label for="enderecoRua" class="form-label">Rua</label>
          <input type="text" id="enderecoRua" formControlName="enderecoRua" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="enderecoNumeroPredial" class="form-label">Número</label>
          <input type="text" id="enderecoNumeroPredial" formControlName="enderecoNumeroPredial" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="enderecoBairro" class="form-label">Bairro</label>
          <input type="text" id="enderecoBairro" formControlName="enderecoBairro" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="enderecoCidade" class="form-label">Cidade</label>
          <input type="text" id="enderecoCidade" formControlName="enderecoCidade" class="form-control">
        </div>

        <div class="col-md-6">
          <label for="enderecoUf" class="form-label">UF</label>
          <select id="enderecoUf" formControlName="enderecoUf" class="form-control">
            <option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</option>
          </select>
        </div>

        <div class="col-md-6">
          <label for="enderecoPais" class="form-label">País</label>
          <input type="text" id="enderecoPais" formControlName="enderecoPais" class="form-control">
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="funcionarioForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
